import { LinkIconPosition } from "./interfaces";
export var defaultProps = {
  color: 'primary70',
  fontWeight: 'medium',
  textDecoration: 'underline',
  iconPosition: LinkIconPosition.Trailing,
  iconVerticalAlign: 'text-top'
};
export var LINK_ICON_SPACING = 4;